import { render } from "./ImgArea.vue?vue&type=template&id=5e2b1acc&scoped=true"
import script from "./ImgArea.vue?vue&type=script&lang=js"
export * from "./ImgArea.vue?vue&type=script&lang=js"

import "./ImgArea.vue?vue&type=style&index=0&id=5e2b1acc&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2b1acc"]])

export default __exports__